






























































































































































































































































import Vue from 'vue';
import validate from '@/utils/validate';
import { Component, Watch } from 'vue-property-decorator';
import { TRules } from '@/types/utils';
import { TLessonInfo } from '@/types/views/educational';
import {
  getLessonById,
  updateLesson,
  startLesson,
  pushProject,
  pushTheme
} from '@/api/educational';
// test https://sit.miaocode.com/scratch/?#934063
//      https://scratch.miaocode.com/#1459278
let tUrl = ''
if (window.location.origin.indexOf('sit') > -1 || window.location.origin.indexOf('localhost') > -1) {
  tUrl = 'https://sit.miaocode.com/scratch/?#'
} else {
  tUrl = 'https://scratch.miaocode.com/#'
}
@Component({
  components: {
    exerciseDesc: () => import('./courseware-exercise.vue')
  }
})
export default class Info extends Vue {
  public $refs!: {
    form: any;
    exerciseDesc: any;
  };

  private url = tUrl;
  private urlcpp = process.env.VUE_APP_URL.replace('https', 'http').replace(
    '/core',
    '/cpp/#/?projectId='
  );
  private urlpython = 'http://py.miaocode.com/cpp/#/?projectId=';
  private loading = false;
  private startTime = '';
  private lessonInfo: TLessonInfo = {
    lessonName: '',
    sequence: '',
    status: '',
    startTime: '',
    minutes: '',
    lessonType: '',
    knowledge: '',
    lessonDes: '',
    homework: '',
    previewVideoUrl: '',
    reviewVideoUrl: '',
    projectId: '',
    themeName: '',
    lessonWorksPracticeList: []
  };
  private form = {
    practices: [{ baseProjectId: '', title: '', content: '', type: 1 }], // 练习
    practices2: [{ baseProjectId: '', title: '', content: '', type: 0 }] // 练习
  };
  private pushProjectBtn = []; // 推送
  private pushProjectBtn2 = []; // 推送
  private practices: any = null;
  private exerciseDescBodyindex = 0; // 练习富文本
  private rules: TRules = {
    minutes: [
      {
        required: true,
        validator: validate.validatorNumber_rule,
        trigger: 'blur'
      }
    ],
    startTime: [
      {
        required: true,
        validator: validate.validatorDateS_rule,
        trigger: 'blur'
      }
    ]
  };
  private secondVerify = {
    themeVerify: true,
    projectVerify: true
  };

  private mounted() {
    this.getLesson();
  }

  private activated() {
    this.getLesson();
  }
  private async getLesson() {
    console.log('1111');
    try {
      this.lessonInfo = await getLessonById({
        lessonId: this.$route.params.id
      });
      if (this.lessonInfo) {
        this.form = {
          practices:
            this.lessonInfo.lessonWorksPracticeList &&
            this.lessonInfo.lessonWorksPracticeList.filter((v: any) => {
              return v.type == 1;
            }).length > 0
              ? this.lessonInfo.lessonWorksPracticeList.filter((v: any) => {
                  return v.type == 1;
                })
              : [{ baseProjectId: '', title: '', content: '', type: 1 }],
          practices2:
            this.lessonInfo.lessonWorksPracticeList &&
            this.lessonInfo.lessonWorksPracticeList.filter((v: any) => {
              return v.type == 0;
            }).length > 0
              ? this.lessonInfo.lessonWorksPracticeList.filter((v: any) => {
                  return v.type == 0;
                })
              : [{ baseProjectId: '', title: '', content: '', type: 0 }]
        };
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async updateLesson() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        try {
          // this.lessonInfo.startTime =
          //   new Date(this.lessonInfo.startTime).getTime() + '';
          let condition = {
            ...this.lessonInfo,
            startTime: new Date(this.lessonInfo.startTime).getTime()
          };
          let practicesList = this.form.practices.map((item: any, k) => {
            return {
              type: item.type || 1,
              sort: k + 1,
              baseProjectId: item.baseProjectId,
              title: item.title ? item.title : '练习' + (k + 1),
              id: item.id,
              lessonId: this.lessonInfo.lessonId,
              content: item.content
                ? item.content == '请完成老师布置的练习'
                  ? '<p>请完成老师布置的练习</p>'
                  : item.content
                : '<p>请完成老师布置的练习</p>'
            };
          });
          let practicesList2 = this.form.practices2.map((item: any, k) => {
            return {
              type: item.type || 0,
              sort: k + 1,
              baseProjectId: item.baseProjectId,
              title: item.title ? item.title : '练习' + (k + 1),
              id: item.id,
              lessonId: this.lessonInfo.lessonId,
              content: item.content
                ? item.content == '请完成老师布置的练习'
                  ? '<p>请完成老师布置的练习</p>'
                  : item.content
                : '<p>请完成老师布置的练习</p>'
            };
          });
          condition.lessonWorksPracticeList = practicesList.concat(
            practicesList2
          );
          const data = await updateLesson({
            lessonDTOStr: JSON.stringify(condition)
          });
          data && this.$message.success('更新课时成功');
        } catch (e) {
          this.$message.error(e.message);
        }
      } else {
        this.$message.error('请填写完整');
        return false;
      }
    });
  }
  private async startLesson() {
    try {
      const res: any = await startLesson({
        lessonRoomId: this.lessonInfo.lessonRoomId || '123456'
      });
      res.code === '000001' && window.open(res.data, '_blank');
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async sendHalfProject() {
    let options = {
      lessonId: this.lessonInfo.id,
      projectId: this.lessonInfo.projectId
    };
    if (!options.lessonId) {
      console.log('lessonId不存在');
      return;
    }
    if (!options.projectId) {
      console.log('projectId 不存在');
      this.$message.error('请填入基础作品ID');
      return;
    }
    if (this.secondVerify.projectVerify) {
      try {
        this.secondVerify.projectVerify = false;
        await pushProject(options);
        this.secondVerify.projectVerify = true;
        this.$message.success('推送成功');
      } catch (e) {
        this.secondVerify.projectVerify = true;
        this.$message.error(e.message);
      }
    }
  }
  // 推送主题包
  private async sendThemetoUser() {
    let options = {
      lessonId: this.lessonInfo.id,
      themeId: this.lessonInfo.themeId
    };
    if (!options.lessonId) {
      console.log('lessonId不存在');
      return;
    }
    if (!options.themeId) {
      console.log('themeId 不存在');
      this.$message.error('请填入主题包名称');
      return;
    }
    if (this.secondVerify.themeVerify) {
      try {
        this.secondVerify.themeVerify = false;
        await pushTheme(options);
        this.secondVerify.themeVerify = true;
        this.$message.success('推送成功');
      } catch (e) {
        this.secondVerify.themeVerify = true;
        this.$message.error(e.message);
      }
    }
  }

  private addExerciseList(type: any) {
    // 添加练习
    if (type == 1) {
      this.form.practices.push({
        baseProjectId: '',
        title: '',
        content: '',
        type: 1
        // title: "练习" + (this.form.knowledgePointList.length + 1)
      });
    } else {
      this.form.practices2.push({
        baseProjectId: '',
        title: '',
        content: '',
        type: 0
        // title: "练习" + (this.form.knowledgePointList.length + 1)
      });
    }
  }
  private deleteExerciseList(index: any, type: any) {
    if (type == 1) {
      this.form.practices.splice(index, 1);
    } else {
      this.form.practices2.splice(index, 1);
    }
  }
  private editExerciseDesc(index: any, type: any) {
    //打开练习描述弹窗
    if (type == 1) {
      this.practices = this.form.practices;
    } else {
      this.practices = this.form.practices2;
    }

    this.exerciseDescBodyindex = index;
    this.$refs.exerciseDesc.index = index;
    this.$refs.exerciseDesc.type = type;
    this.$refs.exerciseDesc.dialogFormVisible = true;
  }
  changeBody(opts: any) {
    this.exerciseDescBodyindex = opts.index;
    if (opts.type == 1) {
      this.form.practices[this.exerciseDescBodyindex].content = opts.content;
    } else {
      this.form.practices2[this.exerciseDescBodyindex].content = opts.content;
    }
  }
  // 推送练习
  async sendHalfProject2(id: any, index: any, type: any) {
    let options = {
      lessonId: this.lessonInfo.id,
      lessonPracticeId: id
    };
    if (!options.lessonId) {
      console.log('lessonId不存在');
      return;
    }
    if (!options.lessonPracticeId) {
      console.log('projectId 不存在');
      this.$message.error('请填入练习ID');
      return;
    }
    // if(this.secondVerify.projectVerify) {
    try {
      if (type == 1) {
        this.pushProjectBtn.length = index + 1;
        this.pushProjectBtn.splice(index, 1);
      } else {
        this.pushProjectBtn2.length = index + 1;
        this.pushProjectBtn2.splice(index, 1);
      }
      console.log(this.pushProjectBtn);
      // this.secondVerify.projectVerify = false;
      await pushProject(options);
      // this.secondVerify.projectVerify = true;
      this.pushProjectBtn = [];
      this.pushProjectBtn2 = [];
      this.$message.success('推送成功');
    } catch (e) {
      this.pushProjectBtn = [];
      this.pushProjectBtn2 = [];
      // this.$message.error(e.message)
    }
    // }
  }
}
